import React, { useEffect, useState } from 'react';
import ShareList from './ShareList';
import Share from '../../../basicInfo/Share';

/**
 * 상품 공유하기 컴포넌트
 */
function DealShare() {
  const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);
  /* 공유타임 페이지 유무 */
  const isShareDeal = TMON.htStaticData.isShareDeal;
  /* 공유 유무 */
  const hasShareDeal = TMON.htStaticData.shareDealInfo.hasSharedDeal;
  const isShareTooltipOpen = isShareDeal && (!TMON.bLogin || !hasShareDeal);

  useEffect(() => {
    const oShare = new Share();
    return () => {
      oShare.clearEvent();
      TMON.oApp.oFixedShare.clearEvent();
      setIsSharePopupOpen(false);
    };
  }, []);

  const handleSharePopupOpen = e => {
    e.preventDefault();

    /* 공유 했거나 공유타임 페이지가 아닌경우 보여주는 팝업 */
    if (hasShareDeal || !isShareDeal) {
      if (TMON.sDevice === 'PW') {
        setIsSharePopupOpen(true);
      } else {
        TMON.oApp.oFixedShare.open();
      }
      /* 공유페이지면서 공유를 안했을 때 보여주는 팝업 */
    } else if (isShareDeal && !hasShareDeal) {
      TMON.oApp.oShareDealPopup.open();
    }
  };

  const handleSharePopupClose = e => {
    e.preventDefault();
    setIsSharePopupOpen(false);
  };

  const setSharebtnTl = () => {
    const tlObject = {};
    if (isShareDeal) {
      if (TMON.bMobile) {
        tlObject['tl:area'] = 'SDMSC';
      } else {
        tlObject['tl:area'] = 'SDPSC';
      }
    } else {
      tlObject['tl:area'] = 'DDS0';
    }
    tlObject['tl-ord'] = 1;
    return tlObject;
  };

  return (
    <>
      <div className="deal_share">
        <button
          type="button"
          className="button_share"
          aria-label="딜 공유하기"
          data-role="toggleShare"
          {...setSharebtnTl()}
          onClick={e =>
            isSharePopupOpen
              ? handleSharePopupClose(e)
              : handleSharePopupOpen(e)
          }
        >
          <span className="text">공유</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 22"
          >
            <path
              fill="none"
              fillRule="evenodd"
              stroke="#7D7E80"
              d="M16.158 14.89c1.57 0 2.842 1.286 2.842 2.873 0 1.587-1.272 2.873-2.842 2.873s-2.842-1.286-2.842-2.873c0-1.587 1.272-2.874 2.842-2.874zM3.842 7.991c1.57 0 2.842 1.287 2.842 2.874 0 1.587-1.272 2.874-2.842 2.874S1 12.453 1 10.866C1 9.28 2.272 7.992 3.842 7.992zM16.158 1C17.728 1 19 2.287 19 3.874c0 1.587-1.272 2.873-2.842 2.873s-2.842-1.286-2.842-2.873C13.316 2.287 14.588 1 16.158 1zM5.756 8.716l8.15-3.772m-8.15 7.838l8.15 3.885"
            />
          </svg>
        </button>

        {TMON.sDevice === 'PW' && (!isShareDeal || hasShareDeal) && (
          <div
            className="pop_toolbox share_wrap"
            // snsShare 모듈의 로드 시점 때문에 display로 제어
            style={{ display: isSharePopupOpen ? 'block' : 'none' }}
          >
            <div className="inner">
              <div className="ct">
                <div className="share-lst-wrap">
                  <ShareList />
                </div>
              </div>
              <button
                type="button"
                className="btn_clse"
                onClick={handleSharePopupClose}
              >
                닫기
              </button>
            </div>
          </div>
        )}
        {isShareTooltipOpen && (
          <div className="share_deal on">
            <span className="share_deal_text">공유 후 구매할 수 있습니다</span>
          </div>
        )}

        <input
          type="text"
          id="clip_target"
          style={{
            position: 'absolute',
            overflow: 'hidden',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: 0,
            clip: 'rect(0 0 0 0)',
            border: 0,
          }}
        />
      </div>
    </>
  );
}

export default DealShare;
